module.exports = __webpack_public_path__ + "static/media/bg2_.14cfa454.webp";